import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React, { useRef, useContext, useState, useEffect, useMemo, cloneElement, useCallback } from 'react';
import { useGesture } from 'react-use-gesture';
import { nanoid } from 'nanoid/non-secure';
import '../../utils/assertions.es.js';
import { ResponsiveContext } from '../../utils/responsive.es.js';
import { scrollIntoView } from '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import styled from 'styled-components';
import { useEnhancedEffect } from '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Skeleton } from '../Skeleton/Skeleton.es.js';
import '../../assets/icons/custom/CheckIcon.es.js';
import '../../assets/icons/generated/filled/AndroidFilled.es.js';
import '../../assets/icons/generated/filled/AppleFilled.es.js';
import '../../assets/icons/generated/filled/ArrowForwardFilled.es.js';
import '../../assets/icons/generated/filled/CameraAddFilled.es.js';
import '../../assets/icons/generated/filled/CameraFilled.es.js';
import '../../assets/icons/generated/filled/CdPauseFilled.es.js';
import '../../assets/icons/generated/filled/CheckCircleFilled.es.js';
import '../../assets/icons/generated/filled/CommentsFilled.es.js';
import '../../assets/icons/generated/filled/CommentsTextFilled.es.js';
import '../../assets/icons/generated/filled/CreditCardFilled.es.js';
import '../../assets/icons/generated/filled/CrownFilled.es.js';
import '../../assets/icons/generated/filled/DownloadCircleFilled.es.js';
import '../../assets/icons/generated/filled/FacebookFilled.es.js';
import '../../assets/icons/generated/filled/FolderFilled.es.js';
import '../../assets/icons/generated/filled/HeartFilled.es.js';
import '../../assets/icons/generated/filled/HelpFilled.es.js';
import '../../assets/icons/generated/filled/InfoFilled.es.js';
import '../../assets/icons/generated/filled/InstagramFilled.es.js';
import '../../assets/icons/generated/filled/KebabFilled.es.js';
import '../../assets/icons/generated/filled/LightningFilled.es.js';
import '../../assets/icons/generated/filled/LinkFilled.es.js';
import '../../assets/icons/generated/filled/LinkedinFilled.es.js';
import '../../assets/icons/generated/filled/LockFilled.es.js';
import '../../assets/icons/generated/filled/MasterFilled.es.js';
import '../../assets/icons/generated/filled/MeatballsFilled.es.js';
import '../../assets/icons/generated/filled/PauseFilled.es.js';
import '../../assets/icons/generated/filled/PlayFilled.es.js';
import '../../assets/icons/generated/filled/RecordFilled.es.js';
import '../../assets/icons/generated/filled/RedditFilled.es.js';
import '../../assets/icons/generated/filled/ReleasesFilled.es.js';
import '../../assets/icons/generated/filled/RemoveFilled.es.js';
import '../../assets/icons/generated/filled/ReplyFilled.es.js';
import '../../assets/icons/generated/filled/SpotifyFilled.es.js';
import '../../assets/icons/generated/filled/StarFilled.es.js';
import '../../assets/icons/generated/filled/StarHalfFilled.es.js';
import '../../assets/icons/generated/filled/StopFilled.es.js';
import '../../assets/icons/generated/filled/TwitterFilled.es.js';
import '../../assets/icons/generated/filled/UsersFilled.es.js';
import '../../assets/icons/generated/filled/VolumeFilled.es.js';
import '../../assets/icons/generated/filled/VolumeMuteFilled.es.js';
import '../../assets/icons/generated/filled/WarningFilled.es.js';
import '../../assets/icons/generated/filled/WindowsFilled.es.js';
import '../../assets/icons/generated/filled/XFilled.es.js';
import '../../assets/icons/generated/filled/YoutubeFilled.es.js';
import '../../assets/icons/generated/outlined/CalendarOutlined.es.js';
import '../../assets/icons/generated/outlined/AddFileOutlined.es.js';
import '../../assets/icons/generated/outlined/AddOutlined.es.js';
import '../../assets/icons/generated/outlined/AddReleaseOutlined.es.js';
import '../../assets/icons/generated/outlined/AddToCollectionOutlined.es.js';
import '../../assets/icons/generated/outlined/AddSongOutlined.es.js';
import '../../assets/icons/generated/outlined/AlbumOutlined.es.js';
import '../../assets/icons/generated/outlined/ArchiveOutlined.es.js';
import ArrowBackOutlined from '../../assets/icons/generated/outlined/ArrowBackOutlined.es.js';
import ArrowForwardOutlined from '../../assets/icons/generated/outlined/ArrowForwardOutlined.es.js';
import '../../assets/icons/generated/outlined/ArrowDownOutlined.es.js';
import '../../assets/icons/generated/outlined/ArrowUpOutlined.es.js';
import '../../assets/icons/generated/outlined/AttachmentOutlined.es.js';
import '../../assets/icons/generated/outlined/AudioLinesOutlined.es.js';
import '../../assets/icons/generated/outlined/BassOutlined.es.js';
import '../../assets/icons/generated/outlined/BellOutlinedOff.es.js';
import '../../assets/icons/generated/outlined/BellOutlined.es.js';
import '../../assets/icons/generated/outlined/BentoOutlined.es.js';
import '../../assets/icons/generated/outlined/BlocksOutlined.es.js';
import '../../assets/icons/generated/outlined/CameraOffOutlined.es.js';
import '../../assets/icons/generated/outlined/CameraOutlined.es.js';
import '../../assets/icons/generated/outlined/CancelOutlined.es.js';
import '../../assets/icons/generated/outlined/CaretDownOutlined.es.js';
import '../../assets/icons/generated/outlined/CaretLeftOutlined.es.js';
import '../../assets/icons/generated/outlined/CaretRightOutlined.es.js';
import '../../assets/icons/generated/outlined/CaretUpOutlined.es.js';
import '../../assets/icons/generated/outlined/CdArrowOutlined.es.js';
import '../../assets/icons/generated/outlined/CdTimerOutlined.es.js';
import '../../assets/icons/generated/outlined/CheckOutlined.es.js';
import '../../assets/icons/generated/outlined/CheckCircleOutlined.es.js';
import '../../assets/icons/generated/outlined/ClockHistoryOutlined.es.js';
import '../../assets/icons/generated/outlined/ClockOutlined.es.js';
import '../../assets/icons/generated/outlined/CloseOutlined.es.js';
import '../../assets/icons/generated/outlined/CloudUploadOutlined.es.js';
import '../../assets/icons/generated/outlined/CogOutlined.es.js';
import '../../assets/icons/generated/outlined/CommentMusicNoteOutlined.es.js';
import '../../assets/icons/generated/outlined/ComputerDesktopOutlined.es.js';
import '../../assets/icons/generated/outlined/CopyOutlined.es.js';
import '../../assets/icons/generated/outlined/CouponOutlined.es.js';
import '../../assets/icons/generated/outlined/CreditCardOutlined.es.js';
import '../../assets/icons/generated/outlined/CrownOutlined.es.js';
import '../../assets/icons/generated/outlined/DeliveryOutlined.es.js';
import '../../assets/icons/generated/outlined/DiskOutlined.es.js';
import '../../assets/icons/generated/outlined/DownloadOutlined.es.js';
import '../../assets/icons/generated/outlined/DragOutlined.es.js';
import '../../assets/icons/generated/outlined/DrumsOutlined.es.js';
import '../../assets/icons/generated/outlined/EditOutlined.es.js';
import '../../assets/icons/generated/outlined/EmojiOutlined.es.js';
import '../../assets/icons/generated/outlined/ExpandOutlined.es.js';
import '../../assets/icons/generated/outlined/ExternalLinkOutlined.es.js';
import '../../assets/icons/generated/outlined/FeatherOutlined.es.js';
import '../../assets/icons/generated/outlined/FileOutlined.es.js';
import '../../assets/icons/generated/outlined/FileTextOutlined.es.js';
import '../../assets/icons/generated/outlined/FilterOutlined.es.js';
import '../../assets/icons/generated/outlined/FiltersOutlined.es.js';
import '../../assets/icons/generated/outlined/FlagOutlined.es.js';
import '../../assets/icons/generated/outlined/FolderMusic.es.js';
import '../../assets/icons/generated/outlined/FolderOutlined.es.js';
import '../../assets/icons/generated/outlined/GiftOutlined.es.js';
import '../../assets/icons/generated/outlined/GlobeOutlined.es.js';
import '../../assets/icons/generated/outlined/GrandPianoOutlined.es.js';
import '../../assets/icons/generated/outlined/GridOutlined.es.js';
import '../../assets/icons/generated/outlined/GuitarOutlined.es.js';
import '../../assets/icons/generated/outlined/HandCoinsOutlined.es.js';
import '../../assets/icons/generated/outlined/HandOutlined.es.js';
import '../../assets/icons/generated/outlined/HandshakeOutlined.es.js';
import '../../assets/icons/generated/outlined/HeadphonesAddOutlined.es.js';
import '../../assets/icons/generated/outlined/HeadphonesCheckedOutlined.es.js';
import '../../assets/icons/generated/outlined/HeadphonesOutlined.es.js';
import '../../assets/icons/generated/outlined/HeartOutlined.es.js';
import '../../assets/icons/generated/outlined/HelpOutlined.es.js';
import '../../assets/icons/generated/outlined/HideOutlined.es.js';
import '../../assets/icons/generated/outlined/ImageOutlined.es.js';
import '../../assets/icons/generated/outlined/InfoOutlined.es.js';
import '../../assets/icons/generated/outlined/KeyOutlined.es.js';
import '../../assets/icons/generated/outlined/KeyboardOutlined.es.js';
import '../../assets/icons/generated/outlined/LeaveLeftOutlined.es.js';
import '../../assets/icons/generated/outlined/LeaveOutlined.es.js';
import '../../assets/icons/generated/outlined/ListOutlined.es.js';
import '../../assets/icons/generated/outlined/ListUnorderedOutlined.es.js';
import '../../assets/icons/generated/outlined/ListMusicNoteOutlined.es.js';
import '../../assets/icons/generated/outlined/LockOutlined.es.js';
import '../../assets/icons/generated/outlined/LogoOutlined.es.js';
import '../../assets/icons/generated/outlined/LoopOutlined.es.js';
import '../../assets/icons/generated/outlined/MagicWandOutlined.es.js';
import '../../assets/icons/generated/outlined/MailOutlined.es.js';
import '../../assets/icons/generated/outlined/MenuInvertedOutlined.es.js';
import '../../assets/icons/generated/outlined/MenuOutlined.es.js';
import '../../assets/icons/generated/outlined/MessageCircleHeartOutlined.es.js';
import '../../assets/icons/generated/outlined/MicrophoneOffOutlined.es.js';
import '../../assets/icons/generated/outlined/MicrophoneOutlined.es.js';
import '../../assets/icons/generated/outlined/MinimizeOutlined.es.js';
import '../../assets/icons/generated/outlined/MinusOutlined.es.js';
import '../../assets/icons/generated/outlined/MobilePhoneOutlined.es.js';
import '../../assets/icons/generated/outlined/MoneyOutlined.es.js';
import '../../assets/icons/generated/outlined/MonitorOffOutlined.es.js';
import '../../assets/icons/generated/outlined/MonitorOutlined.es.js';
import '../../assets/icons/generated/outlined/MoveToFolderOutlined.es.js';
import '../../assets/icons/generated/outlined/MusicNoteOff.es.js';
import '../../assets/icons/generated/outlined/MusicNote.es.js';
import '../../assets/icons/generated/outlined/NetworkOutlined.es.js';
import '../../assets/icons/generated/outlined/NoteOutlined.es.js';
import '../../assets/icons/generated/outlined/OrderOutlined.es.js';
import '../../assets/icons/generated/outlined/PackOutlined.es.js';
import '../../assets/icons/generated/outlined/PaperPlaneOutlined.es.js';
import '../../assets/icons/generated/outlined/PencilOutlined.es.js';
import '../../assets/icons/generated/outlined/PencilPaperOutlined.es.js';
import '../../assets/icons/generated/outlined/PercentageOutlined.es.js';
import '../../assets/icons/generated/outlined/PhoneOutlined.es.js';
import '../../assets/icons/generated/outlined/PianoOutlined.es.js';
import '../../assets/icons/generated/outlined/PlaylistOutlined.es.js';
import '../../assets/icons/generated/outlined/PlugOutlined.es.js';
import '../../assets/icons/generated/outlined/PlusOutlined.es.js';
import '../../assets/icons/generated/outlined/PreserverOutlined.es.js';
import '../../assets/icons/generated/outlined/PriceTagOutlined.es.js';
import '../../assets/icons/generated/outlined/ProductBlogOutlined.es.js';
import '../../assets/icons/generated/outlined/ProductNetworkOutlined.es.js';
import '../../assets/icons/generated/outlined/ProductPluginsOutlined.es.js';
import '../../assets/icons/generated/outlined/ProductProjectsOutlined.es.js';
import '../../assets/icons/generated/outlined/ProductReleasesOutlined.es.js';
import '../../assets/icons/generated/outlined/ProductSamplesOutlined.es.js';
import '../../assets/icons/generated/outlined/ProfileOutlined.es.js';
import '../../assets/icons/generated/outlined/ProviderOutlined.es.js';
import '../../assets/icons/generated/outlined/QuoteOutlined.es.js';
import '../../assets/icons/generated/outlined/RemoveOutlined.es.js';
import '../../assets/icons/generated/outlined/RepeatOutlined.es.js';
import '../../assets/icons/generated/outlined/ReplaceOutlined.es.js';
import '../../assets/icons/generated/outlined/ReplyOutlined.es.js';
import '../../assets/icons/generated/outlined/SearchOutlined.es.js';
import '../../assets/icons/generated/outlined/SendFileToOutlined.es.js';
import '../../assets/icons/generated/outlined/SharingOutlined.es.js';
import '../../assets/icons/generated/outlined/ShowOutlined.es.js';
import '../../assets/icons/generated/outlined/SidebarOutlined.es.js';
import '../../assets/icons/generated/outlined/SliderOutlined.es.js';
import '../../assets/icons/generated/outlined/SoundOutlined.es.js';
import '../../assets/icons/generated/outlined/StarOutlined.es.js';
import '../../assets/icons/generated/outlined/StemsOutlined.es.js';
import '../../assets/icons/generated/outlined/StoreOutlined.es.js';
import '../../assets/icons/generated/outlined/SuccessOutlined.es.js';
import '../../assets/icons/generated/outlined/SunOutlined.es.js';
import '../../assets/icons/generated/outlined/ThreadOutlined.es.js';
import '../../assets/icons/generated/outlined/TiktokOutlined.es.js';
import '../../assets/icons/generated/outlined/TrashOutlined.es.js';
import '../../assets/icons/generated/outlined/TrendingUpOutlined.es.js';
import '../../assets/icons/generated/outlined/UpDownOutlined.es.js';
import '../../assets/icons/generated/outlined/UploadOutlined.es.js';
import '../../assets/icons/generated/outlined/UserMessageOutlined.es.js';
import '../../assets/icons/generated/outlined/UserOutlined.es.js';
import '../../assets/icons/generated/outlined/UserPlusOutlined.es.js';
import '../../assets/icons/generated/outlined/UsersOutlined.es.js';
import '../../assets/icons/generated/outlined/VideoChatOutlined.es.js';
import '../../assets/icons/generated/outlined/VideoOffOutlined.es.js';
import '../../assets/icons/generated/outlined/VideoOnOutlined.es.js';
import '../../assets/icons/generated/outlined/VideoOutlined.es.js';
import '../../assets/icons/generated/outlined/VideoRecordingOutlined.es.js';
import '../../assets/icons/generated/outlined/VideoSquareOutlined.es.js';
import '../../assets/icons/generated/outlined/WarningOutlined.es.js';
import '../../assets/icons/generated/outlined/WaveformMirrorOutlined.es.js';
import '../../assets/icons/generated/products/Blog.es.js';
import '../../assets/icons/generated/products/ChromaticDark.es.js';
import '../../assets/icons/generated/products/Chromatic.es.js';
import '../../assets/icons/generated/products/CommunityChannels.es.js';
import '../../assets/icons/generated/products/Courses.es.js';
import '../../assets/icons/generated/products/Creator.es.js';
import '../../assets/icons/generated/products/Distribution.es.js';
import '../../assets/icons/generated/products/Insider.es.js';
import '../../assets/icons/generated/products/LandrFx.es.js';
import '../../assets/icons/generated/products/Mastering.es.js';
import '../../assets/icons/generated/products/NetworkPro.es.js';
import '../../assets/icons/generated/products/NetworkServices.es.js';
import '../../assets/icons/generated/products/Network.es.js';
import '../../assets/icons/generated/products/Plugins.es.js';
import '../../assets/icons/generated/products/ProjectsBlue.es.js';
import '../../assets/icons/generated/products/ProjectsRed.es.js';
import '../../assets/icons/generated/products/SamplesDark.es.js';
import '../../assets/icons/generated/products/Samples.es.js';
import '../../assets/icons/generated/products/SessionsDark.es.js';
import '../../assets/icons/generated/products/Sessions.es.js';
import '../../assets/icons/generated/products/Tutorials.es.js';
import '../../assets/icons/generated/products/Vocalign.es.js';
import { useBreakpoint } from '../../hooks/useBreakpoint/useBreakpoint.es.js';
import { useDebouncedCallback } from '../../hooks/useDebouncedCallback/useDebouncedCallback.es.js';
import 'body-scroll-lock';
import '../../hooks/useNotification/useNotification.es.js';
import '../../hooks/useToast/useToast.es.js';
import '@popperjs/core';
import 'react-beautiful-dnd';
import 'use-callback-ref';
import { IconButton } from '../IconButton/IconButton.es.js';
import { getItemsPerPage } from './helpers.es.js';
import { Styled } from './styled.es.js';
import DotNavigation from './components/DotNavigation.es.js';
import useAutoNavigation from './useAutoNavigation.es.js';
import getSuggestedCurrentSlide from './helpers/getSuggestedCurrentSlide.es.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var arrows = [{
  direction: "left",
  key: "ArrowLeft"
}, {
  direction: "right",
  key: "ArrowRight"
}];
var ArrowButton = styled(IconButton).attrs(function (_ref) {
  var side = _ref.side;
  return {
    hideTooltip: true,
    variant: "secondary",
    kind: "solid",
    isRounded: true,
    "data-testid": "arrow-" + side,
    icon: side === "left" ? ArrowBackOutlined : ArrowForwardOutlined
  };
}).withConfig({
  componentId: "sc-1eogfzn-0"
})(["transition:all 0.5s ease;"]);

var Carousel = function Carousel(_a) {
  var _b = _a,
      items = _b.items,
      slidesPerPage = _b.slidesPerPage,
      onNavigate = _b.onNavigate,
      gutter = _b.gutter,
      arrowOffset = _b.arrowOffset,
      _b$arrowPosition = _b.arrowPosition,
      arrowPosition = _b$arrowPosition === void 0 ? "outside" : _b$arrowPosition,
      _b$hideArrows = _b.hideArrows,
      hideArrows = _b$hideArrows === void 0 ? false : _b$hideArrows,
      itemsOffset = _b.itemsOffset,
      keyboardNavigation = _b.keyboardNavigation,
      scrollToSelection = _b.scrollToSelection,
      _b$selectionEnabled = _b.selectionEnabled,
      selectionEnabled = _b$selectionEnabled === void 0 ? true : _b$selectionEnabled,
      _b$initialSelection = _b.initialSelection,
      initialSelection = _b$initialSelection === void 0 ? 0 : _b$initialSelection,
      onSlideSelected = _b.onSlideSelected,
      _b$lazyloading = _b.lazyloading,
      lazyloading = _b$lazyloading === void 0 ? true : _b$lazyloading,
      dotPosition = _b.dotPosition,
      _b$dotSize = _b.dotSize,
      dotSize = _b$dotSize === void 0 ? "xxl" : _b$dotSize,
      autoNavigationDelay = _b.autoNavigationDelay,
      props = __objRest(_b, ["items", "slidesPerPage", "onNavigate", "gutter", "arrowOffset", "arrowPosition", "hideArrows", "itemsOffset", "keyboardNavigation", "scrollToSelection", "selectionEnabled", "initialSelection", "onSlideSelected", "lazyloading", "dotPosition", "dotSize", "autoNavigationDelay"]);

  var carouselContainerRef = useRef(null);
  var scrollContainerRef = useRef(null);

  var _useContext = useContext(ResponsiveContext),
      breakpoints = _useContext.breakpoints;

  var _useState = useState(false),
      hasBeenInteracted = _useState[0],
      setHasBeenInteracted = _useState[1];

  useEffect(function () {
    var currentCarouselContainer = carouselContainerRef.current;

    if (!currentCarouselContainer) {
      return;
    }

    function handleBeenInteracted() {
      setHasBeenInteracted(true);
      currentCarouselContainer == null ? void 0 : currentCarouselContainer.removeEventListener("mouseover", handleBeenInteracted);
      currentCarouselContainer == null ? void 0 : currentCarouselContainer.removeEventListener("touchstart", handleBeenInteracted);
    }

    currentCarouselContainer.addEventListener("mouseover", handleBeenInteracted);
    currentCarouselContainer.addEventListener("touchstart", handleBeenInteracted);
    return function () {
      currentCarouselContainer.removeEventListener("mouseover", handleBeenInteracted);
      currentCarouselContainer.removeEventListener("touchstart", handleBeenInteracted);
    };
  }, []);

  var _useState2 = useState(0),
      currentSlide = _useState2[0],
      setCurrentSlide = _useState2[1];

  var _useState3 = useState(initialSelection),
      currentSelection = _useState3[0],
      setCurrentSelection = _useState3[1];

  var _useState4 = useState({
    left: false,
    right: false
  }),
      arrowsVisibleState = _useState4[0],
      setArrowsVisibleState = _useState4[1];

  var isMobile = useBreakpoint("md");
  var isBreakPointXXL = useBreakpoint("xxl");
  useEnhancedEffect(function () {
    var currentScrollContainer = scrollContainerRef.current;

    if (!currentScrollContainer) {
      return;
    }

    function preventKeyboardScroll(e) {
      if ([32, 37, 38, 39, 40].includes(e.keyCode)) {
        e.preventDefault();
      }
    }

    currentScrollContainer.addEventListener("keydown", preventKeyboardScroll);
    return function () {
      currentScrollContainer.removeEventListener("keydown", preventKeyboardScroll);
    };
  }, []);
  var itemsPerPage = useMemo(function () {
    return typeof slidesPerPage === "number" ? slidesPerPage : getItemsPerPage(slidesPerPage, breakpoints);
  }, [breakpoints, slidesPerPage]);
  var itemsToRender = useMemo(function () {
    return items.map(function (item, index) {
      var isPreloadAllowed = lazyloading && !hasBeenInteracted ? index <= itemsPerPage : true;

      if (!item.key) {
        throw new Error("Each Carousel Slide must have a unique key.");
      }

      return (
        /* @__PURE__ */
        React.createElement(Styled.CarouselSlide, {
          key: item.key,
          gutter: gutter || 0,
          slidesPerPage: itemsPerPage,
          "data-carousel-slide": index,
          offset: itemsOffset
        }, isPreloadAllowed &&
        /* @__PURE__ */
        React.createElement(Styled.CarouselSlideInner, {
          offset: itemsOffset
        },
        /*#__PURE__*/
        cloneElement(item, {
          draggable: false,
          onMouseDown: function onMouseDown(event) {
            return event.preventDefault();
          },
          isSelected: selectionEnabled ? index === currentSelection : void 0,
          setSelected: selectionEnabled ? function () {
            setCurrentSelection(index);
          } : void 0
        })), !isPreloadAllowed &&
        /* @__PURE__ */
        React.createElement(Styled.CarouselSlideInner, {
          offset: itemsOffset
        },
        /* @__PURE__ */
        React.createElement(Skeleton, null)))
      );
    });
  }, [currentSelection, gutter, items, itemsOffset, itemsPerPage, selectionEnabled, hasBeenInteracted, lazyloading]);
  useEffect(function () {
    var left = false,
        right = false;

    if (!isMobile && !hideArrows) {
      left = currentSlide !== 0;
      right = currentSlide < items.length - itemsPerPage;
    }

    setArrowsVisibleState({
      left: left,
      right: right
    });
  }, [currentSlide, isMobile, items.length, itemsPerPage, hideArrows]);
  var handleScroll = useDebouncedCallback(function (slide, setSlide) {
    if (scrollContainerRef.current) {
      var slideNumber = getSuggestedCurrentSlide(scrollContainerRef.current);

      if (slide !== slideNumber) {
        setSlide(slideNumber);
        setCurrentSlide(slideNumber);
        setCurrentSelection(slideNumber);
        scrollToSlide(slideNumber);
      } else {
        scrollToSlide(slide);
      }
    }
  }, 300);
  var scrollToSlide = useCallback(function (slideNumber, withScrollIntoView) {
    if (withScrollIntoView === void 0) {
      withScrollIntoView = true;
    }

    var currentScrollContainer = scrollContainerRef.current;

    if (!currentScrollContainer) {
      return;
    }

    var slide = currentScrollContainer.querySelector("[data-carousel-slide=\"" + slideNumber + "\"]");
    setCurrentSelection(slideNumber);

    if (onNavigate && currentSlide !== slideNumber) {
      onNavigate(slideNumber);
    }

    if (slide && withScrollIntoView) {
      scrollIntoView(slide, {
        behavior: "smooth",
        inline: "start",
        block: "nearest",
        boundary: currentScrollContainer
      });
    }
  }, [onNavigate, currentSlide]);
  var updateSlide = useDebouncedCallback(function () {
    if (scrollContainerRef.current) {
      var slideNumber = getSuggestedCurrentSlide(scrollContainerRef.current);
      scrollToSlide(slideNumber);
    }
  }, 300);
  var handleDotNavigationClick = useCallback(function (slideNumber, withScrollIntoView) {
    if (withScrollIntoView === void 0) {
      withScrollIntoView = true;
    }

    onSlideSelected && onSlideSelected(slideNumber);
    scrollToSlide(slideNumber, withScrollIntoView);
  }, [onSlideSelected, scrollToSlide]);
  useEnhancedEffect(function () {
    window.addEventListener("resize", updateSlide);
    return function () {
      return window.removeEventListener("resize", updateSlide);
    };
  }, []);
  var getNextCurrentSlide = useCallback(function (side, numberToScroll) {
    var scrollBy = typeof numberToScroll === "undefined" ? itemsPerPage : numberToScroll;
    return side === "ArrowRight" ? Math.min(currentSlide + scrollBy, items.length - itemsPerPage) : Math.max(currentSlide - scrollBy, 0);
  }, [currentSlide, items.length, itemsPerPage]);
  var changeCurrentSlide = useCallback(function (side, numberToScroll) {
    setHasBeenInteracted(true);
    var newCurrentSlide = getNextCurrentSlide(side, numberToScroll);
    setCurrentSlide(newCurrentSlide);
    setCurrentSelection(newCurrentSlide);
    scrollToSlide(newCurrentSlide);
  }, [getNextCurrentSlide, scrollToSlide]);
  var autoscrollToSelection = useCallback(function (newSelection) {
    if (scrollToSelection && newSelection !== null) {
      var isSelectionOffPage = newSelection < currentSlide || newSelection >= currentSlide + itemsPerPage;

      if (isSelectionOffPage) {
        var pageWithSelection = itemsPerPage * Math.floor(newSelection / itemsPerPage);
        setCurrentSlide(pageWithSelection);
        scrollToSlide(pageWithSelection);
      }
    }
  }, [scrollToSelection, currentSlide, itemsPerPage, scrollToSlide]);
  var changeSelection = useCallback(function (side) {
    if (!selectionEnabled) {
      return;
    }

    var newSelection = currentSelection;

    if (currentSelection === null) {
      newSelection = 0;
    } else if (side === "ArrowLeft" && currentSelection > 0) {
      newSelection = currentSelection - 1;
    } else if (side === "ArrowRight" && currentSelection < items.length - 1) {
      newSelection = currentSelection + 1;
    }

    setHasBeenInteracted(true);
    setCurrentSelection(newSelection);
    newSelection && autoscrollToSelection(newSelection);
    onSlideSelected && onSlideSelected(newSelection);
  }, [autoscrollToSelection, currentSelection, items.length, onSlideSelected, selectionEnabled]);
  useEffect(function () {
    function handleKeyDown(e) {
      var key = e.key;

      if (key === "ArrowRight" || key === "ArrowLeft") {
        if (keyboardNavigation === "page") {
          changeCurrentSlide(key, itemsPerPage);
        } else if (typeof keyboardNavigation === "number") {
          changeCurrentSlide(key, keyboardNavigation);
        } else if (keyboardNavigation === "selection") {
          changeSelection(key);
        }
      }
    }

    if (keyboardNavigation) {
      document.addEventListener("keydown", handleKeyDown);
    }

    return function () {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [changeCurrentSlide, changeSelection, itemsPerPage, keyboardNavigation]);
  useEffect(function () {
    var currentScrollContainer = scrollContainerRef.current;

    if (!currentScrollContainer) {
      return;
    }

    var boundScrollFunction = handleScroll.bind({}, currentSlide, setCurrentSlide);
    currentScrollContainer.addEventListener("scroll", boundScrollFunction);
    return function () {
      currentScrollContainer.removeEventListener("scroll", boundScrollFunction);
    };
  }, [itemsPerPage, onNavigate, items, handleScroll, currentSlide, isMobile]);
  var momentumID = useRef(0);
  var scrollLeftMomentum = useCallback(function (velocity, movement) {
    var velocityRef = Math.min(velocity, 10);

    function momentumLoop() {
      if (scrollContainerRef == null ? void 0 : scrollContainerRef.current) {
        var previousScrollLeft = scrollContainerRef.current.scrollLeft;
        scrollContainerRef.current.scrollLeft -= velocityRef / 10 * movement;
        velocityRef *= 0.95;

        if (previousScrollLeft !== scrollContainerRef.current.scrollLeft && Math.abs(velocityRef) > 0.5) {
          momentumID.current = requestAnimationFrame(momentumLoop);
        }
      }
    }

    cancelAnimationFrame(momentumID.current);
    momentumID.current = requestAnimationFrame(momentumLoop);
  }, []);
  useEffect(function () {
    return function () {
      cancelAnimationFrame(momentumID.current);
    };
  }, []);
  var hasDragged = React.useRef(false);
  var bindGesture = useGesture({
    onDrag: function onDrag(_ref2) {
      var first = _ref2.first,
          last = _ref2.last,
          event = _ref2.event,
          velocity = _ref2.velocity,
          movement = _ref2.movement,
          _ref2$delta = _ref2.delta,
          mx = _ref2$delta[0];

      if (first) {
        hasDragged.current = true;
      }

      if (last) {
        setTimeout(function () {
          hasDragged.current = false;
        }, 0);
      }

      if (scrollContainerRef == null ? void 0 : scrollContainerRef.current) {
        if ((event == null ? void 0 : event.type) === "mousemove") {
          scrollContainerRef.current.scrollLeft -= mx;
        }

        if ((event == null ? void 0 : event.type) === "mouseup") {
          scrollLeftMomentum(velocity, movement[0]);
        }
      }
    },
    onScroll: function onScroll(_ref3) {
      var last = _ref3.last;

      if (last && scrollContainerRef.current) {
        var slideNumber = getSuggestedCurrentSlide(scrollContainerRef.current);
        scrollToSlide(slideNumber, false);
      }
    },
    onClickCapture: function onClickCapture(event) {
      if (hasDragged.current) {
        event.preventDefault();
        event.stopPropagation();
      }
    }
  }, {
    drag: {
      axis: "x",
      filterTaps: true
    }
  });

  var _useAutoNavigation = useAutoNavigation({
    carouselContainerRef: carouselContainerRef,
    currentSelection: currentSelection,
    autoNavigationDelay: autoNavigationDelay,
    length: items.length,
    setCurrentSelection: setCurrentSelection,
    scrollToSlide: scrollToSlide,
    setHasBeenInteracted: setHasBeenInteracted
  }),
      ariaLive = _useAutoNavigation.ariaLive,
      isAutoNavigatingActive = _useAutoNavigation.isAutoNavigatingActive;

  var transitionDelay = isAutoNavigatingActive ? autoNavigationDelay : 0;
  var arrowOffsetFromDotSize = dotPosition === "outside" ? dotSize : void 0;
  return (
    /* @__PURE__ */
    React.createElement(Styled.Wrapper, __spreadValues({
      ref: carouselContainerRef,
      role: "region",
      "aria-live": ariaLive,
      id: "carousel-" + nanoid()
    }, props),
    /* @__PURE__ */
    React.createElement(Styled.ScrollContainer, __spreadValues({
      ref: scrollContainerRef,
      gutter: gutter,
      offset: itemsOffset,
      isMobile: isMobile
    }, bindGesture()), itemsToRender), arrows.map(function (_ref4) {
      var direction = _ref4.direction,
          key = _ref4.key;
      return (
        /* @__PURE__ */
        React.createElement(Styled.ArrowWrapper, {
          direction: direction,
          arrowPosition: arrowPosition,
          key: "carousel-arrow-" + direction,
          className: arrowsVisibleState[direction] ? "showing" : ""
        },
        /* @__PURE__ */
        React.createElement(ArrowButton, {
          label: "",
          hideTooltip: true,
          size: isBreakPointXXL ? "sm" : "md",
          side: direction,
          onClick: function onClick() {
            return changeCurrentSlide(key, itemsPerPage);
          },
          mb: arrowOffset || arrowOffsetFromDotSize
        }))
      );
    }), dotPosition &&
    /* @__PURE__ */
    React.createElement(DotNavigation, {
      dotPosition: dotPosition,
      dotSize: dotSize,
      length: items.length,
      currentSelection: currentSelection,
      onClick: handleDotNavigationClick,
      transitionDelay: transitionDelay
    }))
  );
};

Carousel.displayName = "Carousel";
export { Carousel };